import React from 'react';
import { FiMapPin, FiPhone } from 'react-icons/fi';
import './Header.css'; // Assuming you have the CSS for header styles

const Header = () => {
  return (
    <header className='hideme spacetop' style={{display:'flex', alignItems:'center', textAlign:'center', justifyContent:'space-between', padding:'1.5%', boxShadow:'', marginBottom:''}}>
      <div className='left' style={{display:'flex'}}>
          <FiMapPin
            className="w-5 h-5 text-gray-500 flex-shrink-0 mt-1"
            style={{ fontSize: '250%' }}
          />
          &nbsp;
          <span style={{ fontSize: '22px' }}>
           <small style={{color:"#f7931e", fontWeight:600}}> No. 3 Mactech Opp Osun State Govt,
            
            Annex Oke-fia Osogbo</small>
          </span>
        </div>

        <div className="right" style={{display:'flex'}}>
          <FiPhone
            className="w-5 h-5 text-gray-500 flex-shrink-0 mt-1"
            style={{ fontSize: '250%' }}
          />
          &nbsp;
          <span className="uppercase" style={{ fontSize: '22px'}}>
            Call us any time:
            <small style={{color:"#f7931e", fontWeight:600}}> 08102787845 </small>
          </span>
        </div>
    </header>
  );
};

export default Header;
